/**
 * Pasaporte de ejemplo para invitados.
 * Solo se muestra; no se guarda hasta que hay sesión.
 */

export const DEMO_PASSPORT = {
	id: "demo",
	displayName: "Viajero",
	isDemo: true,
};

export const DEMO_PASSPORT_COUNTRIES = [
	{
		id: "demo-jp",
		countryCode: "JP",
		countryName: "Japón",
		city: "Tokio",
		visitDate: "2024-04-12",
		notes: "Shibuya, templos y ramen a todas horas.",
		photos: [],
		order: 0,
	},
	{
		id: "demo-us",
		countryCode: "US",
		countryName: "Estados Unidos",
		city: "Nueva York",
		visitDate: "2023-09-03",
		notes: "Manhattan a pie y atardecer en el ferry.",
		photos: [],
		order: 1,
	},
	{
		id: "demo-gb",
		countryCode: "GB",
		countryName: "Reino Unido",
		city: "Londres",
		visitDate: "2023-06-18",
		notes: "Mercados, museos y un tea de verdad.",
		photos: [],
		order: 2,
	},
	{
		id: "demo-fr",
		countryCode: "FR",
		countryName: "Francia",
		city: "París",
		visitDate: "2022-10-08",
		notes: "Orillas del Sena y un croissant a las 8.",
		photos: [],
		order: 3,
	},
	{
		id: "demo-kr",
		countryCode: "KR",
		countryName: "Corea del Sur",
		city: "Seúl",
		visitDate: "2024-11-02",
		notes: "Barrios, palacios y noche en Hongdae.",
		photos: [],
		order: 4,
	},
];
